import wishlistPageModule from '../scripts/wishlistPage/wishlistPage.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(wishlistPageModule);